export const formatNumberToGB = (amt?: number | null) => {
  if (typeof amt !== "number") return "";

  return amt?.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
